import { Locales } from 'intlayer'

type Locale = typeof Locales.ENGLISH | typeof Locales.PORTUGUESE_BRAZIL

type LocalePort = {
	get(): Locale
	set(locale: Locale): void
}

const locales = [Locales.ENGLISH, Locales.PORTUGUESE_BRAZIL]
const defaultLocale: Locale = Locales.PORTUGUESE_BRAZIL

export type { Locale, LocalePort }
export { locales, defaultLocale }
